export default function Findable(Base) {
    const makeEndpoint = (operation) => {
        return `${Base.service}/${operation}`;
    };
    return class Findable extends Base {
        /**
         * Find entity matched by query
         */
        find(params) {
            const endpoint = makeEndpoint('find');
            return this.apiClient.exec(endpoint, params);
        }
        /**
         * Find entities matched by query
         */
        findMany(params) {
            const endpoint = makeEndpoint('find-many');
            return this.apiClient.exec(endpoint, params);
        }
        /**
         * Find entities in batches
         *
         * ```
         * for await (const result of client.findManyPaged('.foo', 1, 15, { id: true })) {
         *   // result = [{id: 'foo'}, {id: 'bar'}]
         * }
         * ```
         */
        findManyPaged({ query, pageSize, specs, }) {
            const queryArray = typeof query === 'string' ? [query] : query;
            let pageIndex = 0;
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const client = this;
            async function* fetchPaged() {
                let result;
                const limit = pageSize + 1;
                while (true) {
                    const skip = pageIndex * pageSize;
                    const fullQuery = `${queryArray[0]}:skip(${skip}):limit(${limit})`;
                    result = await client.findMany({ query: fullQuery, specs });
                    const slice = result.slice(0, pageSize);
                    pageIndex++;
                    if (result.length >= limit) {
                        yield slice;
                    }
                    else {
                        return slice;
                    }
                }
            }
            return fetchPaged();
        }
    };
}
